export const PERMISSIONS = {
  location: {
    name: '定位',
    tips: '定位权限使用说明：用于获取当前位置，方便为您获取所在城市的差旅信息',
    android: 'android.permission.ACCESS_FINE_LOCATION',
  },
  camera: {
    name: '相机',
    tips: '相机权限使用说明：用于拍摄发票、凭证等场景',
    android: 'android.permission.CAMERA',
  },
  album: {
    name: '相册',
    tips: '相册权限使用说明：用于上传发票、凭证等场景',
    android: 'android.permission.READ_EXTERNAL_STORAGE',
  },
  record: {
    name: '麦克风',
    tips: '麦克风权限使用说明：用于录制音频，视频等场景',
    android: 'android.permission.RECORD_AUDIO',
  },
  push: {
    name: '推送',
    tips: '推送权限使用说明：用于接收推送消息',
    android: 'android.permission.RECEIVE_BOOT_COMPLETED',
  },
  contact: {
    name: '通讯录',
    tips: '通讯录权限使用说明：用于获取通讯录信息',
    android: 'android.permission.READ_CONTACTS',
  },
  calendar: {
    name: '日历',
    tips: '日历权限使用说明：用于获取日历信息',
    android: 'android.permission.READ_CALENDAR',
  },
  memo: {
    name: '备忘录',
    tips: '备忘录权限使用说明：用于获取备忘录信息',
    android: 'android.permission.READ_CALENDAR',
  },
  callPhone: {
    name: '打电话',
    tips: '打电话权限使用说明：用于联系客服、联系司机等场景',
    android: 'android.permission.CALL_PHONE',
  },
  sendSMS: {
    name: '发短信',
    tips: '发短信权限使用说明：用于发送短信验证码',
    android: 'android.permission.SEND_SMS',
  },
};

export const permissionIDs = Object.keys(PERMISSIONS);
